// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".job-gallery[data-v-524ee4ea]{grid-column-gap:8px;display:grid}.job-gallery>*[data-v-524ee4ea]{gap:8px}.job-gallery__media[data-v-524ee4ea]{height:-moz-fit-content;height:fit-content}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
